import React from 'react';
import LastUpdatedIndicator from './LastUpdatedIndicator';
import PerformanceMetrics from './PerformanceMetrics';

const InstrumentPerformance = () => {
    return (
        <div className="instrument-performance-container">
            <div className={'row'}>
                <div className={'col'}>
                    <PerformanceMetrics />
                </div>
                <div className={'col-auto d-none d-lg-block'}>
                    <LastUpdatedIndicator showMarketOpenTime={true}/>
                </div>
            </div>
        </div>
    );
};

export default InstrumentPerformance;
